import gsap from "gsap";
import AbstractComponent from "./abstract-component";

  export default class SiteFooter extends AbstractComponent {

    constructor(el) {
        super(el);
        this.DOM = {};
        this._moved = false;
        this._mq = window.matchMedia('(max-width: 767px)');
        this.initDomElements();
        this.initEvents();
        this.handleResponsivePlacement();
        this._mq.addEventListener ? this._mq.addEventListener('change', () => this.handleResponsivePlacement()) : window.addEventListener('resize', () => this.handleResponsivePlacement());
    }

    initDomElements() {
        this.DOM = {}
        this.DOM.form = this.$el.querySelector( '.wpcf7' )
        this.DOM.formWrapper = this.$el.querySelector( '.form-wrapper' )
        this.DOM.sucessMessage = this.$el.querySelector( '.success-message' )
        this.DOM.scrollTopBtn = this.$el.querySelector('.c-site-footer__bottom__top-button')

        // Newsletter block and left menu anchor
        this.DOM.newsletter = this.$el.querySelector('.c-site-footer__newsletter-form')
        // First submenu in the left column (first column without offset)
        this.DOM.firstLeftSubmenu = this.$el.querySelector('.row > .col-4.col-md-14 .c-site-footer__submenu')

        // Save original placement to restore on desktop
        if (this.DOM.newsletter) {
            this._originalParent = this.DOM.newsletter.parentNode
            this._originalNext = this.DOM.newsletter.nextElementSibling
        }
    }
    initEvents(){
        if (this.DOM.form) {
            const formId = this.DOM.form?.getAttribute('id') || 'footer-newsletter';
            
            // Log de soumission
            if (this.DOM.formEl) {
                this.DOM.formEl.addEventListener('submit', () => {
                    console.log(`[CF7 Submit] Footer form submission started: ${formId}`);
                }, true);
            }
            
            // Log d'erreur de validation
            this.DOM.form.addEventListener('wpcf7invalid', (e) => {
                console.warn(`[CF7 Submit] Footer form validation failed: ${formId}`, e.detail);
            });
            
            // Log de soumission en cours
            this.DOM.form.addEventListener('wpcf7submit', (e) => {
                console.log(`[CF7 Submit] Footer form submitted (processing): ${formId}`, e.detail);
            });
            
            // Log de succès
            this.DOM.form.addEventListener('wpcf7mailsent', (e) => {
                console.log(`[CF7 Submit] Footer form sent successfully: ${formId}`, e.detail);
                gsap.to(this.DOM.formWrapper,{autoAlpha:0,duration:0.5,onComplete:()=>{
                    gsap.set(this.DOM.formWrapper,{display:'none'})
                    gsap.set(this.DOM.sucessMessage,{display:'block'})
                    gsap.fromTo(this.DOM.sucessMessage,{x:5},{x:0,duration:0.5})
                }})
            });
            
            // Log d'échec
            this.DOM.form.addEventListener('wpcf7mailfailed', (e) => {
                console.error(`[CF7 Submit] Footer form send failed: ${formId}`, e.detail);
            });
        }
        // Back to top: clic uniquement sur le bouton (comme c-header__scroller), pas au hover
        const scrollTopBtn = this.DOM.scrollTopBtn;
        if (scrollTopBtn) {
            const btn = scrollTopBtn.querySelector('.js-scroll-to-top-button') || scrollTopBtn;
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                if (this.app?.$scroll?.lenis) {
                    // Même logique que le header scroller, durée plus longue pour remonter tout en haut
                    this.app.$scroll.lenis.scrollTo('top', {
                        duration: 2,
                        easing: (t) => 1 - Math.pow(1 - t, 3),
                    });
                } else if (this.app?.$scroll?.scrollTo) {
                    this.app.$scroll.scrollTo(0);
                } else {
                    try {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    } catch (err) {
                        window.scrollTo(0, 0);
                    }
                }
            }, { passive: false });
        }
    }
    handleResponsivePlacement(){
        if (!this.DOM.newsletter || !this.DOM.firstLeftSubmenu) { return }
        const isMobile = this._mq.matches
        if (isMobile && !this._moved) {
            // Move newsletter before first left submenu
            const leftColumn = this.DOM.firstLeftSubmenu.parentNode
            leftColumn.insertBefore(this.DOM.newsletter, this.DOM.firstLeftSubmenu)
            this._moved = true
        } else if (!isMobile && this._moved) {
            // Restore to original place in right column
            if (this._originalParent) {
                if (this._originalNext) {
                    this._originalParent.insertBefore(this.DOM.newsletter, this._originalNext)
                } else {
                    this._originalParent.appendChild(this.DOM.newsletter)
                }
            }
            this._moved = false
        }
    }
    destroy() { }
}